// @flow
import type { Epic } from '../../annotations';
import type { Initialize } from '../../core/ga';

import * as r from 'ramda';
import * as mA from 'most-adjunct';
import { select } from 'redux-most';
import * as signals from '../signals';
import * as mostc from '../../crosscutting/mostc';

type AnalyticsContext = {
  trackerId: string,
};

const gaInitEpic = (
  analyticsContext: AnalyticsContext,
  initialize: Initialize,
): Epic => (
  actions$,
) => r.pipe(
  select(signals.SEED),
  mostc.tap(({
    payload,
  }) => {
    initialize(
      payload.brandId,
      analyticsContext.trackerId
    );
  }),
  mA.ignoreElements,
)(actions$);

export default gaInitEpic;
